module.exports = __webpack_public_path__ + "static/media/pic3.51716512.png";